module.exports = __webpack_public_path__ + "img/exam_jan_2025_131lvovl.05ffd52f.jpg";